module.exports = __webpack_public_path__ + "static/media/google-play-badge.b5e9e225.svg";